import PropTypes from "prop-types";
import { useEffect } from "react";
import { Box, Typography, TextField, Card, CardContent } from "@mui/material";

import { useClient } from "../../context/ClientProvider";


function ArrangementPostalOrder({ account, setConsent }) {

  const { clientSortCode, clientAccountNumber } = useClient();

  useEffect(() => {
    // Enable confirm button by default
    setConsent(true);
  }, []);

  return account && (
    <Card
      sx={{
        borderRadius: { xs: 0, md: 0 },
        pb: 2,
      }}
    >
      <Box>
        {/* Postal order account details */}
        <CardContent>
          <Typography sx={{ fontSize: 18, fontWeight: "bold", mb: 2 }}>
            Postal order details
          </Typography>
          <Typography>
            {`Please use the bank account details provided below to set up your postal order.
              You may want to make a note of these details before confirming the repayment plan.`}
          </Typography>
          <Box
            id="postalOrderSortCode"
            sx={{ mt: 2 }}            
          >
            <Typography
              component='label'
              htmlFor='sortCode'
              fontWeight={"bold"}
            >
              Sort code
            </Typography>
            <Box>
              <TextField
                disabled
                margin='dense'
                required
                id='sortCode'
                name='sortCode'
                value={clientSortCode}
                sx={{
                  backgroundColor: "lightgrey",
                  width: { xs: "100%", md: "40%" }
                }}
              />
            </Box>
          </Box>
          <Box
            id="postalOrderAccountNumber"
            sx={{ mt: 2 }}                          
          >
            <Typography
              component='label'
              htmlFor='accountNumber'
              fontWeight={"bold"}
              sx={{ mt: 1 }}
            >
              Account number
            </Typography>
            <Box>
              <TextField
                disabled
                margin='dense'
                required
                id='accountNumber'
                name='accountNumber'
                value={clientAccountNumber}
                sx={{
                  mb: 5,
                  backgroundColor: "lightgrey",
                  width: { xs: "100%", md: "40%" }
                }}
              />
            </Box>
          </Box>
        </CardContent>
        {/* End of postal order account details */}
      </Box>
    </Card>
  );
};

ArrangementPostalOrder.propTypes = {
  account: PropTypes.object.isRequired,
  setConsent: PropTypes.func.isRequired,
};

export default ArrangementPostalOrder;